{
  "name": "43-(11-Limit) Partch (degree_0 = 1/1, A 440 Hz, HEJI)",
  "description": "Transposition of the 43-tone 11-Limit Rational Intonation scale by Harry Partch, consisting of 43 divisions per octave derived symmetrically from both harmonic and subharmonic partial rows (otonalities and utonalities) up to a prime limit of 11. Partch’s original tuning was based on 1/1 = G, while this version sets 1/1 = C, using the same frequency ratios.",
  "scale": [
    "81/80",
    "33/32",
    "21/20",
    "16/15",
    "12/11",
    "11/10",
    "10/9",
    "9/8",
    "8/7",
    "7/6",
    "32/27",
    "6/5",
    "11/9",
    "5/4",
    "14/11",
    "9/7",
    "21/16",
    "4/3",
    "27/20",
    "11/8",
    "7/5",
    "10/7",
    "16/11",
    "40/27",
    "3/2",
    "32/21",
    "14/9",
    "11/7",
    "8/5",
    "18/11",
    "5/3",
    "27/16",
    "12/7",
    "7/4",
    "16/9",
    "9/5",
    "20/11",
    "11/6",
    "15/8",
    "40/21",
    "64/33",
    "160/81",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "43-JI-11L(Partch)",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "C",
    "C",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "E",
    "E",
    "F",
    "E",
    "F",
    "F",
    "F",
    "F",
    "G",
    "F",
    "G",
    "G",
    "G",
    "G",
    "A",
    "G",
    "A",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "B",
    "C",
    "C"
  ],
  "note_colors": [
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#ece6df",
    "#dee2da",
    "#cee3e2",
    "#e2eecd",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#dfffd6",
    "#fffae5",
    "#bae5f7",
    "#e2caca",
    "#ffe5e5",
    "#ffffff",
    "#dee2da",
    "#dfffd6",
    "#ece6df",
    "#ecc9a2",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#e4fbe6",
    "#dee2da",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#d0d0d7",
    "#dee2da",
    "#e2eecd",
    "#dfffd6",
    "#fffae5",
    "#ecc9a2",
    "#cee3e2",
    "#fffae5"
  ],
  "equivSteps": 43,
  "fundamental": 440,
  "reference_degree": 32,
  "center_degree": 0,
  "rSteps": 7,
  "drSteps": 4,
  "hexSize": 42,
  "rotation": -16.102113751
}
